import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';

interface Props {
  variant?: 'customer' | 'admin';
}

export default function AppLayout({ variant = 'customer' }: Props) {
  return (
    <div className="min-h-screen bg-surface flex flex-col">
      <Sidebar variant={variant} />
      <main className="ml-sidebar flex-1 p-6">
        <Outlet />
      </main>
      <footer className="ml-sidebar border-t border-border py-4 px-6 text-xs text-muted">
        <span>&copy; 2026 Graziano Labs Corp. All rights reserved.</span>
      </footer>
    </div>
  );
}
